var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90696 7.25579C6.31798 7.20441 6.69282 7.49596 6.7442 7.90697L7.97046 17.7171C8.07993 18.5928 8.82438 19.25 9.70694 19.25H14.293C15.1756 19.25 15.92 18.5928 16.0295 17.7171L17.2558 7.90697C17.3072 7.49596 17.682 7.20441 18.093 7.25579C18.504 7.30717 18.7956 7.68201 18.7442 8.09302L17.5179 17.9031C17.3146 19.5295 15.9321 20.75 14.293 20.75H9.70694C8.06789 20.75 6.68534 19.5295 6.48204 17.9031L5.25578 8.09302C5.2044 7.68201 5.49595 7.30717 5.90696 7.25579Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H19C19.4142 5.25 19.75 5.58579 19.75 6C19.75 6.41421 19.4142 6.75 19 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37352 3.70588C8.85146 2.80976 9.78439 2.25 10.8 2.25H13.2C14.2156 2.25 15.1485 2.80976 15.6265 3.70588L16.6618 5.64706C16.8567 6.01254 16.7184 6.46684 16.3529 6.66177C15.9875 6.85669 15.5332 6.71842 15.3382 6.35294L14.3029 4.41176C14.0857 4.00444 13.6616 3.75 13.2 3.75H10.8C10.3384 3.75 9.9143 4.00443 9.69705 4.41176L8.66176 6.35294C8.46684 6.71842 8.01254 6.85669 7.64705 6.66176C7.28157 6.46684 7.14331 6.01254 7.33823 5.64706L8.37352 3.70588Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11.25C13.9142 11.25 14.25 11.5858 14.25 12V14C14.25 14.4142 13.9142 14.75 13.5 14.75C13.0858 14.75 12.75 14.4142 12.75 14V12C12.75 11.5858 13.0858 11.25 13.5 11.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.25C10.9142 11.25 11.25 11.5858 11.25 12V14C11.25 14.4142 10.9142 14.75 10.5 14.75C10.0858 14.75 9.75 14.4142 9.75 14V12C9.75 11.5858 10.0858 11.25 10.5 11.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.39cf110b.svg";
export { ForwardRef as ReactComponent };